export default __webpack_public_path__ + "static/planning-poker-voting-ac78af8f8baba0eadc765f5b31912b60.jpg";